import {
  DocumentationItem,
  DocumentationListElementsResponse,
  DocumentationSearchResponse,
  DocumentationDependenciesResponse,
  DocumentationDependentsResponse,
} from './documentation';

export enum SnowflakeParentType {
  TABLE = 'TABLE',
  VIEW = 'VIEW',
  TASK = 'TASK',
  STREAM = 'STREAM',
  PROCEDURE = 'PROCEDURE',
  FUNCTION = 'FUNCTION',
  STAGE = 'STAGE',
  SEQUENCE = 'SEQUENCE',
}

export interface SnowflakeItemBase extends DocumentationItem {
  schema?: string;
  catalog?: string;
  owner?: string;
  comment?: string;
  body?: string;
}

export interface SnowflakeTableItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.TABLE;
  tableType?: string;
  retentionTime?: string;
  clusteringKey?: string;
  isTransient?: string;
  created?: string;
  lastDdl?: string;
  lastDdlBy?: string;
  columnCount?: string;
  isIceberg?: string;
  isDynamic?: string;
  isHybrid?: string;
  autoClusteringOn?: string;
  isTemporary?: string;
}

export interface SnowflakeViewItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.VIEW;
  isSecure?: string;
  isMaterialized?: string;
  queryDefinition?: string;
  created?: string;
  lastAltered?: string;
  columnCount?: string;
  isUpdatable?: string;
}

export interface SnowflakeTaskItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.TASK;
  warehouse?: string;
  schedule?: string;
  state?: string;
  condition?: string;
  predecessors?: string;
  createdOn?: string;
}

export interface SnowflakeStreamItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.STREAM;
  sourceObject?: string;
  streamType?: string;
  stale?: string;
  mode?: string;
  createdOn?: string;
}

export interface SnowflakeProcedureItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.PROCEDURE;
  language?: string;
  arguments?: string;
  returnType?: string;
  executeAs?: string;
  created?: string;
  lastAltered?: string;
}

export interface SnowflakeFunctionItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.FUNCTION;
  language?: string;
  arguments?: string;
  returnType?: string;
  isSecure?: string;
  volatility?: string;
  created?: string;
  lastAltered?: string;
}

export interface SnowflakeStageItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.STAGE;
  stageType?: string;
  url?: string;
  fileFormat?: string;
}

export interface SnowflakeSequenceItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.SEQUENCE;
  increment?: string;
  startValue?: string;
  minValue?: string;
  maxValue?: string;
  dataType?: string;
  created?: string;
  lastAltered?: string;
}

export type SnowflakeConfigurationItem =
  | SnowflakeTableItem
  | SnowflakeViewItem
  | SnowflakeTaskItem
  | SnowflakeStreamItem
  | SnowflakeProcedureItem
  | SnowflakeFunctionItem
  | SnowflakeStageItem
  | SnowflakeSequenceItem;

export type SnowflakeDocumentationListElementsResponse =
  DocumentationListElementsResponse<SnowflakeConfigurationItem>;
export type SnowflakeDocumentationSearchResponse =
  DocumentationSearchResponse<SnowflakeConfigurationItem>;
export type SnowflakeDocumentationDependenciesResponse =
  DocumentationDependenciesResponse<SnowflakeConfigurationItem>;
export type SnowflakeDocumentationDependentsResponse =
  DocumentationDependentsResponse<SnowflakeConfigurationItem>;
